import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToPause = (
    pause$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    pause$
        .subscribe(() => playbackStore.actions.pause());

export default subscribeToPause;